<template>
  <v-app>
    <site-header v-model="drawMenu" />
    <custom-menu v-model="drawMenu" v-if="!isMobile" />
    <mobile-menu v-model="drawMenu" v-if="isMobile" />
    <float-form />
    <v-main class="app-light-grey">
      <breadcrumbs />
      <v-overlay z-index="2" :value="drawMenu"></v-overlay>
      <router-view />
    </v-main>
    <site-footer />
    <notifications group="main" position="bottom right" />
  </v-app>
</template>

<script>
import Breadcrumbs from './components/app/Breadcrumbs.vue'
import CustomMenu from './components/app/CustomMenu.vue'
import SiteFooter from './components/app/footer/Footer.vue'
import SiteHeader from './components/app/Header.vue'
import FloatForm from './components/app/FloatForm.vue'
import MobileMenu from './components/app/MobileMenu.vue'
export default {
  name: 'App',
  components: {
    Breadcrumbs,
    SiteHeader,
    SiteFooter,
    CustomMenu,
    FloatForm,
    MobileMenu
  },
  data: () => ({
    drawMenu: false
  }),

  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.mobile
    }
  },
  metaInfo: {
    description:
      'Український розробник та постачальник комплексних рішень на базі програмного забезпечення системи електронного документообігу АСКОД'
  }
}
</script>
<style lang="scss">
.v-main__wrap {
  display: flex;
  flex-direction: column;
}
</style>
